import { API_BASE_URL } from '@/api/path';

export interface Group {
  id: string;
  name: string;
  description: string | null;
  type: string;
  memberCount: number;
  isChecked: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface GroupStats {
  totalGroups: number;
  associatedGroups: number;
}

export interface AvailableGroupsResponse {
  success: boolean;
  data: {
    groups: Group[];
    total: number;
    stats: GroupStats;
    source: string;
  };
  timestamp: string;
  message: string;
}

export interface UpdateAssociationsRequest {
  groupIds: string[];
}

export interface UpdateAssociationsResponse {
  success: boolean;
  data: {
    added: { id: string; name: string }[];
    removed: { id: string; name: string }[];
    totalAssociations: number;
  };
  timestamp: string;
  message: string;
}

export const groupManagementApi = {
  getAvailableGroups: async (): Promise<AvailableGroupsResponse> => {
    const response = await fetch(
      `${API_BASE_URL}/api/business-groups-management/available-groups`,
      {
        credentials: 'include',
      },
    );

    if (!response.ok) {
      throw new Error('Failed to fetch groups');
    }

    return response.json() as Promise<AvailableGroupsResponse>;
  },

  updateAssociations: async (
    request: UpdateAssociationsRequest,
  ): Promise<UpdateAssociationsResponse> => {
    const response = await fetch(
      `${API_BASE_URL}/api/business-groups-management/update-associations`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(request),
      },
    );

    if (!response.ok) {
      throw new Error('Failed to update group associations');
    }

    return response.json() as Promise<UpdateAssociationsResponse>;
  },
};
